module.exports = __webpack_public_path__ + "assets/img/tenthTwo.9cb32cd4.jpg";